import { LocationDto } from './models';

export class LocationDtoEmpty implements LocationDto{
  name = '';
}